if (document.querySelector(".accordion__trigger")) {
    $(document).on("click", ".accordion__trigger", function (event) {
        event.preventDefault();
        let accordionItem = $(this).closest(".accordion__item");

        if (!accordionItem.hasClass("open")) {
            $(".accordion__item.open").removeClass("open").find(".accordion__content").slideUp("fast");

            accordionItem.addClass("open");
            accordionItem.find(".accordion__content").slideDown("fast");
        } else {
            accordionItem.removeClass("open");
            accordionItem.find(".accordion__content").slideUp("fast");
        }
    });
}
